import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, IconButton, Typography, useMediaQuery } from '@mui/material';
import {
  TheatersRounded,
  GraphicEqRounded,
  AddShoppingCartRounded,
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ROUTES from '@src/constants/route';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import { FEATURE, PACKAGE_STUDIO_VERSION } from '@src/constants/package';
import { useCheckDubbingRoute } from '@src/hooks/useCheckDubbingRoute';
import PackageInfo from '@src/containers/Layout/SidebarNew/PackageInfo';
import theme from '@src/styles/theme';
import SwiperPackageInfo from '@src/containers/Layout/SidebarNew/SwiperPackageInfo';
import PackageInfoV3 from '@src/containers/Layout/SidebarNew/PackageInfoV3';
import { StyledTitleProduct, StyledTooltip } from './index.style';

const TitleProduct = ({ useNewSidebarV2, isSMSUser, isNewHeaderUI }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { pathname } = window.location;
  const { getFeatureValue } = useFeatureFlags();
  const { user } = useSelector((state) => state.auth);

  const useShowMultiplePackagesInfo = getFeatureValue(
    FEATURE_KEYS.SHOW_MULTIPLE_PACKAGES_INFO,
    {
      userId: user.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    },
  );

  const useTitleProduct = getFeatureValue(FEATURE_KEYS.TITLE_PRODUCT, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const useRenameMergeProduct = getFeatureValue(
    FEATURE_KEYS.RENAME_MERGE_PRODUCT,
    {
      userId: user.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    },
  );

  const usePackageInfoV3 = getFeatureValue(FEATURE_KEYS.PACKAGE_INFO_V3, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const ttsPaths = [ROUTES.TTS];
  const dubbingPaths = [
    ROUTES.HOME_DUBBING,
    ROUTES.DUBBING_PROJECT,
    ROUTES.DUBBING,
  ];

  if (!useTitleProduct) {
    return <></>;
  }
  const { usingPackage, usingDubbingPackage, ttsUser } = useSelector(
    (state) => state.user,
  );

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isDubbingRoute = useCheckDubbingRoute();
  const getUserPackageFeature = () => {
    const isPackageV2 =
      usingPackage?.version === PACKAGE_STUDIO_VERSION.V2 ||
      usingPackage?.version === PACKAGE_STUDIO_VERSION.V2_1;

    if (isPackageV2) return ttsUser?.features;

    if (isDubbingRoute) {
      return ttsUser?.dubbing?.features;
    }

    return ttsUser?.features;
  };

  const checkSubtitlePermission = () => {
    const features = getUserPackageFeature();
    const userFeatures = ttsUser?.features;
    return (
      usingPackage?.id &&
      (features?.includes(FEATURE.SUBTITLE) ||
        userFeatures?.includes(FEATURE.SUBTITLE))
    );
  };

  const renderPackageInfo = () => {
    // if this feature is enabled, we will use the new sidebar v2
    if (usePackageInfoV3)
      return (
        <PackageInfoV3
          isSMSUser={isSMSUser}
          useNewSidebarV2={useNewSidebarV2}
        />
      );

    if (useShowMultiplePackagesInfo && !isSMSUser && isDubbingRoute)
      return (
        <SwiperPackageInfo
          isSMSUser={isSMSUser}
          useNewSidebarV2={useNewSidebarV2}
        />
      );

    return (
      <PackageInfo isSMSUser={isSMSUser} useNewSidebarV2={useNewSidebarV2} />
    );
  };

  const userPackageInfo = () => {
    const haveSubtitleFeature = checkSubtitlePermission();
    const icon = haveSubtitleFeature
      ? usingPackage?.icon
      : usingDubbingPackage?.icon;

    return useNewSidebarV2 && !isMobile ? (
      <div className="wallet">
        <Box className="wallet-character">
          {renderPackageInfo()}
          <StyledTooltip title={t('buyPackage')} placement="left">
            <div className="icon-container">
              <IconButton
                size="small"
                color="secondary"
                onClick={() => {
                  if (isDubbingRoute) history.push(ROUTES.PAYMENT_DUBBING);
                  else history.push(ROUTES.PAYMENT);
                }}
                className="icon-btn-tooltip"
              >
                <AddShoppingCartRounded />
              </IconButton>
              {icon && !isSMSUser && !usePackageInfoV3 && (
                <img src={icon} alt="package-icon" className="small-icon" />
              )}
            </div>
          </StyledTooltip>
        </Box>
      </div>
    ) : (
      <></>
    );
  };
  if (ttsPaths.includes(pathname)) {
    const renderTitle = () => {
      if (isSMSUser) return t('aivoiceStudio');

      return useRenameMergeProduct ? t('newStudioName') : t('STUDIO');
    };
    return (
      <StyledTitleProduct
        useNewSidebarV2={useNewSidebarV2}
        isNewHeaderUI={isNewHeaderUI}
      >
        <GraphicEqRounded className="icon" />
        <Typography className="lable-create-new">{renderTitle()}</Typography>
        {userPackageInfo()}
      </StyledTitleProduct>
    );
  }

  if (dubbingPaths.includes(pathname)) {
    const renderTitle = () => {
      if (isSMSUser) return t('DUBBING');

      return useRenameMergeProduct ? t('newDubbingName') : t('DUBBING');
    };
    return (
      <StyledTitleProduct useNewSidebarV2={useNewSidebarV2}>
        <TheatersRounded className="icon" />
        <Typography className="lable-create-new">{renderTitle()}</Typography>
        {userPackageInfo()}
      </StyledTitleProduct>
    );
  }

  return <></>;
};
export default TitleProduct;
